import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CalendarPageComponent } from './components/calendar-page/calendar-page.component';
import { KanbanPageComponent } from './components/kanban-page/kanban-page.component';
import { CalendarApiService } from './services/calendar-api/CalendarApiService';
import { KanbanApiService } from './services/kanban-api/KanbanApiService';

@NgModule({
  declarations: [
    CalendarPageComponent,
    KanbanPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  providers: [
    provideHttpClient(),
    CalendarApiService,
    KanbanApiService,
  ],
  exports: [
    CalendarPageComponent,
    KanbanPageComponent,
  ],
})
export class WorkspaceModule { }
